import { InvoiceMinDto } from 'types/invoices';
import { PrepaymentListItem } from 'types/prepayments';
import { injectCountEndPoint, portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

type TagTypes = 'PrepaymentsList' | 'PrepaymentsCount' | 'PrepaymentsLinkedInvoices';

const APIPrepaymentsSlice = portalAPI
    .enhanceEndpoints({
        addTagTypes: ['PrepaymentsList', 'PrepaymentsCount', 'PrepaymentsLinkedInvoices'] as TagTypes[],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getPrepaymentsWithFilters: accumulatedQueryWithFilters<PrepaymentListItem>(
                builder,
                '/v1/invoices/prepayments/list',
                {
                    providesTags: ['PrepaymentsList'],
                }
            ),
            getPrepaymentsCount: injectCountEndPoint(builder, '/v1/invoices/prepayments', 'PrepaymentsCount', 0),
            getLinkedInvoicesForPrepayments: accumulatedQueryWithFilters<InvoiceMinDto>(
                builder,
                '/v1/invoices/prepayments/linked-invoices',
                {
                    providesTags: ['PrepaymentsLinkedInvoices'],
                }
            ),
        }),
    });

export const {
    useLazyGetPrepaymentsWithFiltersQuery,
    useLazyGetPrepaymentsCountQuery,
    useLazyGetLinkedInvoicesForPrepaymentsQuery,
} = APIPrepaymentsSlice;
